import { CheckCircle, Quotes } from "@phosphor-icons/react";
import { Reveal, SectionHeading } from "@/components/site/Primitives";
import { Badge } from "@/components/ui/badge";
import { LEADERSHIP } from "@/data/content";

export const Leadership = () => (
  <section id="team" data-testid="team-section" className="py-24 md:py-32 bg-white">
    <div className="w-full max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <SectionHeading center overline="The People" title="Meet Our Leadership"
          subtitle="Hands-on partners who personally oversee your compliance and financial reporting." testId="team" />
      </Reveal>
      <div className="mt-16 grid md:grid-cols-2 gap-10">
        {LEADERSHIP.map((p, i) => (
          <Reveal key={p.name} delay={i * 0.12}>
            <div data-testid={`leader-card-${i}`}
              className="card-glow h-full bg-cream rounded-2xl border border-slate-200 p-8 md:p-10 transition-all duration-500 hover:shadow-2xl hover:shadow-navy/10 hover:-translate-y-1.5">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 rounded-full p-[2px] bg-gradient-to-br from-gold via-gold/40 to-navy shrink-0">
                  <div className="w-full h-full rounded-full bg-navy flex items-center justify-center">
                    <span className="font-display text-xl font-bold text-gold">
                      {p.name.split(" ").map((n) => n[0]).join("").slice(0, 2)}
                    </span>
                  </div>
                </div>
                <div>
                  <h3 className="font-display text-2xl font-bold text-navy leading-tight">{p.name}</h3>
                  <p className="text-gold font-semibold text-sm uppercase tracking-wider">{p.role}</p>
                </div>
              </div>
              <p className="mt-6 text-slate-600 leading-relaxed">{p.bio}</p>
              <div className="mt-6 flex flex-wrap gap-2">
                {p.skills.map((s) => (
                  <Badge key={s} data-testid={`leader-${i}-skill-${s.replace(/\W+/g, "-").toLowerCase()}`}
                    className="rounded-full bg-navy/5 text-navy border border-navy/10 font-medium px-3 py-1 hover:bg-gold/10">
                    <CheckCircle size={14} weight="fill" className="text-gold mr-1" /> {s}
                  </Badge>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="py-24 md:py-32 bg-cream">
    <div className="w-full max-w-4xl mx-auto px-6 md:px-12 text-center">
      <Reveal>
        <div className="inline-flex w-16 h-16 rounded-full bg-gold/10 items-center justify-center text-gold mx-auto">
          <Quotes size={34} weight="fill" />
        </div>
        <span className="mt-6 block text-sm font-bold uppercase tracking-[0.2em] text-gold">Testimonials</span>
        <h2 className="mt-3 font-display text-3xl md:text-4xl font-semibold tracking-tight text-navy">What Our Clients Say</h2>
        <p className="mt-6 text-base md:text-lg text-slate-600 leading-relaxed max-w-2xl mx-auto">
          Client testimonials will be published here as we continue serving individuals and businesses across India.
        </p>
      </Reveal>
    </div>
  </section>
);
